import { CheckCircleFilled, DownloadOutlined } from '@ant-design/icons'
import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import MixpanelTracker from '../../services/track/mixpanel'

const Finish: React.FC = () => {
  const history = useHistory()
  const { activityId } = useParams<{ activityId: string }>()

  useEffect(() => {
    // Scroll to the top of the page on mount
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const handleViewActivity = () => {
    if (activityId) {
      MixpanelTracker.track('View Activity Button Click', {
        'Activity ID': activityId,
      })
    }

    const currentHost = window.location.host
    const baseUrl = currentHost.includes('staging') ? 'https://staging.haup.ai' : 'https://haup.ai'
    const url = `${baseUrl}/en/activities/detail/${activityId}`
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const handleDownloadApp = () => {
    window.open('https://www.haupcar.com/download', '_blank', 'noopener,noreferrer')
  }

  const handleBackToSubmission = () => {
    history.push('/submission')
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '24px 16px',
        backgroundColor: 'white',
        minHeight: '100vh',
        boxSizing: 'border-box',
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      {/* Top success section */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          marginBottom: '32px',
        }}
      >
        <div style={{ position: 'relative', width: '200px', height: 'auto', marginBottom: '24px' }}>
          <img
            src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/5d5hnYeCSDBYEJPjPMbNNFLB5X2fJAfkaof4ZCMjVchNRDCbfhfnX2qPYj3wGC7JhqeEazcu45U2hSnpSdi4aesG.png"
            alt="Success illustration"
            style={{ width: '100%', height: 'auto', display: 'block' }}
          />
          <CheckCircleFilled
            style={{
              position: 'absolute',
              bottom: '12%',
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: '48px',
              color: '#00CCCC',
              backgroundColor: 'white',
              borderRadius: '50%',
              boxShadow: '0 4px 12px rgba(0, 204, 204, 0.2)',
            }}
          />
        </div>
        <h1
          style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#212427',
            margin: 0,
            lineHeight: '1.3',
            letterSpacing: '-0.5px',
          }}
        >
          Success! Your activity is now listed on our platform.
        </h1>
      </div>

      {/* Remaining steps section */}
      <div
        style={{
          width: '100%',
          padding: '24px',
          backgroundColor: '#F9FAFB',
          borderRadius: '16px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
          marginBottom: '32px',
        }}
      >
        <h2
          style={{
            fontSize: '20px',
            fontWeight: '700',
            color: '#212427',
            margin: '0 0 24px 0',
          }}
        >
          Remaining steps to finish
        </h2>

        {/* Step List */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Step 1: Completed */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
            <CheckCircleFilled style={{ color: '#00CCCC', fontSize: '24px', marginTop: '2px' }} />
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#212427',
                  lineHeight: '1.4',
                }}
              >
                Submission completed
              </div>
            </div>
          </div>

          {/* Step 2: Completed */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
            <CheckCircleFilled style={{ color: '#00CCCC', fontSize: '24px', marginTop: '2px' }} />
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#212427',
                  lineHeight: '1.4',
                }}
              >
                You activity is listed on the platform
              </div>
            </div>
          </div>

          {/* Step 3: Download App (Incomplete) */}
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '16px',
              position: 'relative',
            }}
          >
            <div
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                border: '2px solid #D6DAE0',
                backgroundColor: 'white',
              }}
            />
            <div
              style={{
                position: 'absolute',
                left: '11px',
                top: '24px',
                width: '2px',
                height: 'calc(100% - 24px)',
                backgroundColor: '#D6DAE0',
              }}
            />
            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '8px',
                }}
              >
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#212427',
                    lineHeight: '1.4',
                  }}
                >
                  Download app
                </span>
                <span
                  style={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#856A00',
                    backgroundColor: '#FFF4CB',
                    padding: '4px 8px',
                    borderRadius: '8px',
                  }}
                >
                  Incomplete
                </span>
              </div>
              <p
                style={{
                  fontSize: '14px',
                  color: '#667085',
                  margin: '0 0 16px 0',
                  lineHeight: '1.5',
                }}
              >
                You need to download our app to manage activity listings, respond to requests and
                track earnings
              </p>
              <button
                onClick={handleDownloadApp}
                style={{
                  padding: '10px 20px',
                  backgroundColor: 'transparent',
                  color: '#0048B3',
                  border: '1px solid #0048B3',
                  borderRadius: '24px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px',
                  fontFamily: 'Poppins, sans-serif',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <DownloadOutlined />
                Download app
              </button>
            </div>
          </div>

          {/* Step 4: Upload New Activities (Incomplete) */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
            <div
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                border: '2px solid #D6DAE0',
                backgroundColor: 'white',
              }}
            />
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#212427',
                  lineHeight: '1.4',
                }}
              >
                Upload new activities
              </div>
              <p
                style={{
                  fontSize: '14px',
                  color: '#667085',
                  margin: '0',
                  lineHeight: '1.5',
                }}
              >
                Share new activities you offer by adding details, photos, and availability to
                attract the right travelers.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Action buttons at the bottom */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          maxWidth: '500px',
          gap: '16px',
        }}
      >
        <button
          onClick={handleBackToSubmission}
          style={{
            flex: '1',
            padding: '12px 24px',
            backgroundColor: 'transparent',
            color: '#0048B3',
            border: '1px solid #0048B3',
            borderRadius: '26px',
            cursor: 'pointer',
            fontWeight: '500',
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            fontFamily: 'Poppins, sans-serif',
          }}
        >
          ← Back
        </button>
        <button
          onClick={handleViewActivity}
          style={{
            flex: '1',
            padding: '12px 24px',
            backgroundColor: '#0048B3',
            color: 'white',
            border: 'none',
            borderRadius: '26px',
            cursor: 'pointer',
            fontWeight: '500',
            fontSize: '16px',
            fontFamily: 'Poppins, sans-serif',
          }}
        >
          View activity
        </button>
      </div>
    </div>
  )
}

export default Finish
